import marketingcloudMenu from './marketingcloud/menu.js';
import expressoMenu from './expresso/menu.js';

const menu = {
    label: 'INTEGRA PE',
    icon: 'pi pi-fw pi-send',
    rules: [...new Set([...marketingcloudMenu.rules, ...expressoMenu.rules])],
    items: [marketingcloudMenu, expressoMenu],
};

export default menu;
